import type { NetworkErrorOptions } from './_network.type';

import { BaseError } from './_base';

/** Network Error. */
export class NetworkError extends BaseError {
  /** Status Code. */
  status: number;

  /** Error Code. */
  code?: string | number;

  /**
   * Create NetworkError instance.
   *
   * @param {NetworkErrorOptions} options Options.
   */
  public constructor({ status, code, ...options }: NetworkErrorOptions) {
    super(options);

    this.status = status;
    this.code = code;
  }
}
